var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditBlogIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4H14V2H16V4H18C19.7071 4 21 5.44474 21 7.11133V8H19V7.11133C19 6.44605 18.502 6 18 6H16V8H14V6H8V8H6V6H4C3.49797 6 3 6.44605 3 7.11133V18.8887C3 19.554 3.49797 20 4 20H18C18.502 20 19 19.554 19 18.8887V18H21V18.8887C21 20.5553 19.7071 22 18 22H4C2.29289 22 1 20.5553 1 18.8887V7.11133C1 5.44474 2.29289 4 4 4H6V2H8V4Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H12V14H21V16ZM23 12H12V10H23V12Z",
    fill: "#F8C244"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditBlogIc);
export default __webpack_public_path__ + "static/media/creditBlog_ic.ffb3eecc51a7c981112c43e660cf2a36.svg";
export { ForwardRef as ReactComponent };